<template>
	<Modal title="Edit Report" modal-width="full-width">
		<div class="alert alert-secondary text-center col-md-12">
			<strong>
				Please note: Changes made here will be reflected across all associated
				reports.
			</strong>
		</div>

		<form @submit.prevent="updateReport()" class="row">
			<div class="col-12">
				<Alert />
			</div>
			<div class="col-md-6">
				<div class="row mb-3">
					<label for="old_report_from" class="col-sm-4 col-form-label">
						Report Period From:<span class="text-danger">*</span>
					</label>
					<div class="col-sm-8">
						<div>
							<input
								:value="report_from"
								name="old_report_from"
								id="old_report_from"
								type="text"
								class="form-control"
								disabled
							/>
							<a
								v-if="!editReportFrom"
								@click.prevent="editReportFrom = true"
								href="#"
								class="btn-link"
								>Click to edit</a
							>
							<a
								v-if="editReportFrom"
								@click.prevent="cancelEdit('report_from')"
								href="#"
								class="btn-link text-danger"
								>Cancel edit</a
							>
						</div>
						<div v-if="editReportFrom" style="margin-top: 1rem">
							<label for="report_from">New report from</label>
							<DateInput name="report_from" id="report_from" required />
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row mb-3">
					<label for="report_to" class="col-sm-4 col-form-label"
						>Report Period To:<span class="text-danger">*</span></label
					>
					<div class="col-sm-8">
						<div>
							<input
								:value="report_to"
								name="report_to"
								id="report_to"
								type="text"
								class="form-control"
								disabled
							/>
							<a
								v-if="!editReportTo"
								@click.prevent="editReportTo = true"
								href="#"
								class="btn-link"
								>Click to edit</a
							>
							<a
								v-if="editReportTo"
								@click.prevent="cancelEdit('report_to')"
								href="#"
								class="btn-link text-danger"
								>Cancel edit</a
							>
						</div>
						<div v-if="editReportTo" style="margin-top: 1rem">
							<label for="report_to">New report to</label>
							<DateInput name="report_to" id="report_to" required />
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row mb-3">
					<label for="approval_document" class="col-sm-4 col-form-label"
						>Approval Document: (optional)</label
					>
					<div class="col-sm-8">
						<div style="margin-bottom: 1rem">
							<a
								:href="form.approval_document"
								target="_blank"
								class="btn btn-link form-control"
								>View Current Document</a
							>
						</div>
						<input
							@change="getFiles()"
							name="approval_document"
							id="approval_document"
							ref="approval_document"
							type="file"
							class="form-control"
						/>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="row mb-3">
					<label for="approved_by" class="col-sm-4 col-form-label"
						>Approved By:<span class="text-danger">*</span></label
					>
					<div class="col-sm-8">
						<input
							v-model="form.approved_by"
							name="approved_by"
							id="approved_by"
							type="text"
							class="form-control"
							required
						/>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="card-footer" align="right" style="padding-right: 0">
					<button class="btn btn-secondary me-2" @click.prevent="hideModal">
						Cancel
					</button>
					<LoadingButton class="btn btn-info">Submit</LoadingButton>
				</div>
			</div>
		</form>
	</Modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import DateInput from "@/components/DateInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { EventBus } from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";
import dayjs from "dayjs";

export default {
	components: {
		LoadingButton,
		DateInput,
		Modal,
		Alert,
	},
	props: {
		report: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			editReportFrom: false,
			editReportTo: false,
			report_from: "",
			report_to: "",
			approval_document: "",
			form: {
				report_id: "",
				report_from: "",
				report_to: "",
				approval_document: "",
				approved_by: "",
			},
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
		}),
	},
	methods: {
		...mapActions({
			editForm: "form_ec16c/editForm",
			getFormDetails: "form_ec16c/getFormDetails",
		}),

		async updateReport() {
			let formData = new FormData();

			formData.append("_method", "PUT");
			formData.append("report_id", this.form.report_id);
			formData.append("approval_document", this.form.approval_document);
			formData.append("report_from", this.form.report_from);
			formData.append("report_to", this.form.report_to);
			formData.append("approved_by", this.form.approved_by);

			await this.editForm(formData).then((res) => {
				if (res.status_code == 201) {
					this.hideModal();
				}
			});
		},

		getFiles() {
			this.form.approval_document = this.$refs.approval_document.files[0];
		},

		setInputs() {
			if (this.report && Object.keys(this.report).length == 0) {
				return;
			}

			this.form.approved_by = this.report.approved_by;
			this.form.report_id = this.report.report_id;
			this.form.report_from = dayjs(this.report.period_from).format(
				"YYYY/MM/DD"
			);
			this.report_from = this.report.period_from_formatted;
			this.report_to = this.report.period_to_formatted;
			this.form.report_to = dayjs(this.report.period_to).format("YYYY/MM/DD");
			this.approval_document = this.report.approval_document;
		},

		cancelEdit(type) {
			if (type == "report_from") {
				this.editReportFrom = false;
				this.form.report_from = dayjs(this.report.period_from).format(
					"YYYY/MM/DD"
				);
			}

			if (type == "report_to") {
				this.editReportTo = false;
				this.form.report_to = dayjs(this.report.period_to).format("YYYY/MM/DD");
			}
		},

		setDateInput(payload) {
			this.form[payload.inputId] = payload.value;
		},

		hideModal() {
			EventBus.$emit("toggle-modal", "hide");
		},
	},
	mounted() {
		EventBus.$on("date-input", this.setDateInput);
		EventBus.$emit("toggle-modal", "show");
		this.setInputs();
	},
};
</script>
<style scoped>
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}
/* td {
	height: 50px;
	padding: 0;
} */
td > input,
select {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: none;
	padding-top: 20px;
	padding-left: 0;
	padding-right: 0;
	border-radius: 0;
	height: 100%;
}
.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
